








import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class EmptyDialogComponent extends Vue {
  @Prop({
    default: false
  })
  public display!: boolean;

  get holderStyle() {
    return {
      display: this.display ? "flex" : "none"
    };
  }
}
